<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';
import AccordionComponent from '@/components/AccordionComponent.vue';
import BackgroundImage from '@/components/BackgroundImage.vue';
import PhoneBubbles from '@/components/phone/PhoneBubbles.vue';

const questions = [
  {
    q: 'Verðlaun og viðurkenning',
    a: '„Likes“, hjörtu og önnur viðbrögð virka eins og umbun sem hvetur okkur til að nota skjátækin okkar aftur og aftur - líkt og hundur sem fær nammi fyrir að hlýða skipun.',
  },
  {
    q: 'Endalaust magn af efni',
    a: 'Efnið í símanum klárast aldrei. Veraldarvefurinn er ekki bók með upphaf og endi - heldur endalaust flæði efnis og upplýsinga sem heldur áfram svo lengi sem við skrollum. Algóritminn er stilltur inn á að halda okkur uppteknum sem lengst, það sem vekur hjá okkur tilfinningaleg viðbrögð og ögrar fær forgang. Næsta myndband byrjar að spilast og við fáum í sífellu ábendingar um fleiri myndbönd til að halda okkur við efnið. Ef okkur leiðist getum við smellt á refresh til að fá nýjan skammt, líkt og við værum í spilakassa.',
  },
  {
    q: 'Árangur',
    a: 'Margir samfélagsmiðlar vilja telja okkur trú um að við séum að ná árangri með notkun þeirra - að fleiri vinir og fylgjendur jafngildi meiri árangri.',
  },
  {
    q: 'Útundanótti (e. FOMO)',
    a: 'Þegar við erum ekki nettengd óttumst við gjarnan að missa af einhverju - nýju trendi, beinni útsendingu eða bara því sem aðrir eru að gera.',
  },
  {
    q: 'Spilar með tilfinningar',
    a: 'Við erum líklegri til að bregðast við efni á netinu sem vekur upp hjá okkur tilfinningaleg viðbrögð.',
  },
  {
    q: 'Allt er áríðandi',
    a: 'Rauðglóandi tilkynningar í smáforritum og á samfélagsmiðlum, titringur og hljóðmerki láta allt virka áríðandi - sama hversu smávægilegt það er í raun.',
  },
];
</script>

<template>
  <section>
    <!-- bg image -->
    <BackgroundImage src="/images/girl-on-a-party.webp" src2="/images/girl-on-a-party-after.webp" start="50" startMobile="-50" alt="stelpa með síma" />
    <BoundedComponent className="-mt-45 md:-mt-70 xl:-mt-120">
      <!-- header -->
      <div class="text-center pb-9">
        <h2 v-fade-up class="mb-1">Verum meðvituð</h2>
        <p v-fade-up class="text-xl font-light mx-10 text-yellow lg:text-white">
          Tækið er hannað til að stela og halda athygli okkar
        </p>
      </div>
      <!-- content -->
      <div
        class="bg-yellow rounded-6xl pt-9 lg:pt-22.5 pb-20 md:pb-6 inner-block-px flex flex-col md:flex-row items-center md:items-start gap-4 lg:gap-10"
      >
        <PhoneBubbles class="self-center" />
        <AccordionComponent :questions="questions" class="md:pr-6 xl:pr-0" />
      </div>
    </BoundedComponent>
  </section>
</template>
